import { Box, Typography } from '@mui/material'
import { triageLevelStates } from '../../../store/reports/types'

const defaultValuesForms: { [key: string]: any } = {
  [triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED]: {
    triageLevel: triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED,
    message: '',
    investigator: [],
  },
  [triageLevelStates.ADDRESSED_AND_RESOLVED]: {
    triageLevel: triageLevelStates.ADDRESSED_AND_RESOLVED,
    issueDescription: '',
    response: '',
  },
  [triageLevelStates.TRANSFERED_FOR_ASSIGNMENT]: {
    triageLevel: triageLevelStates.TRANSFERED_FOR_ASSIGNMENT,
    message: '',
    investigator: [],
  },
  [triageLevelStates.ADDITIONAL_INFORMATION_REQUIRED]: {
    triageLevel: triageLevelStates.ADDITIONAL_INFORMATION_REQUIRED,
  },
  [triageLevelStates.ACCEPTED_AND_ASSIGNED]: {
    triageLevel: triageLevelStates.ACCEPTED_AND_ASSIGNED,
  },
  [triageLevelStates.RESOLVE_AND_ARCHIVE]: {
    triageLevel: triageLevelStates.RESOLVE_AND_ARCHIVE,
  },
}

const initialDefaultValues = {
  triageLevel: '',
  userMessage: '',
  issueDescription: '',
  response: '',
  selectedUsers: [],
}

export const messages = (type: string) => {
  switch (type) {
    case triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED:
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
          <Typography variant='bodyBold'>
            An imminent risk of serious injury or death, or serious damage to company property, is
            reported.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant='bodyRegular' color='black'>
              1. Call 911 or local emergency number or police or fire, if appropriate
            </Typography>
            <Typography variant='bodyRegular' color='black'>
              2. Notify Security, if appropriate
            </Typography>{' '}
            <Typography variant='bodyRegular' color='black'>
              3. Follow emergency procedures, as appropriate
            </Typography>{' '}
          </Box>
        </Box>
      )
    case triageLevelStates.ADDRESSED_AND_RESOLVED:
      return (
        <Typography variant='bodyBold'>
          The Triage Team addressed and resolved the question or concern directly with the Reporting
          Party.
        </Typography>
      )
    case triageLevelStates.RESOLVE_AND_ARCHIVE:
      return (
        <Typography variant='bodyBold'>Resolve this case and move it to the Archive</Typography>
      )
    case triageLevelStates.TRANSFERED_FOR_ASSIGNMENT:
      return (
        <Typography variant='bodyBold'>
          A question, concern, or other report was assigned to an appropriate group for resolution
          or investigation.
        </Typography>
      )
    case triageLevelStates.ADDITIONAL_INFORMATION_REQUIRED:
      return (
        <Typography variant='bodyBold'>
          The Reporting Party did not provide sufficient information to address or investigate the
          issue. The Triage Team will attempt to contact the Reporting Party.
        </Typography>
      )
    case triageLevelStates.ACCEPTED_AND_ASSIGNED:
      return (
        <Typography variant='bodyBold'>
          Proceed to Case Overview to assign team roles, permissions, and other settings.
        </Typography>
      )
    default:
      break
  }
}

export default {
  initialDefaultValues,
  defaultValuesForms,
}
